import Thumbor from 'thumbor-lite';

// Copied from the ImageFormat function on bostonglobe.com.
/**
 * Creates a Thumbor URL for images.
 * @param {number} [height]
 * @param {number} [heightAspect]
 * @param {boolean} [smart]
 * @param {string} src
 * @param {number} [width]
 * @param {number[]} [focalPoint]
 * @param {boolean} [fitIn]
 * @returns {string}
 */
const sizeImage = (
  {
    height,
    heightAspect = null,
    smart = false,
    src,
    width,
    focalPoint = null,
    fitIn = null,
  },
) => {
  if (!src) {
    return src;
  }

  if (src.indexOf('arcpublishing.com') === -1 && src.indexOf('anglerfish') === -1) {
    return src;
  }

  if (!process.env.THUMBOR_TOKEN && process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error('The THUMBOR_TOKEN environment variable has not been set. Check your `.env` files.');
  }

  const thumbor = new Thumbor(
    process.env.THUMBOR_TOKEN,
    'https://bostonglobe-prod.cdn.arcpublishing.com/resizer',
  );

  thumbor.smartCrop(false);
  thumbor.fitInFlag = false;

  // get image url from the tag variable and remove the http/https
  const imgSrc = src.replace(/^http[s]?:\/\//, '').replace(' ', '%20');

  if (imgSrc.includes('?')) imgSrc.replace('?', '%3F');

  // Set the image dimensions
  let imgWidth = 1440;
  let imgHeight = 0;

  if (width || height) {
    imgWidth = width || ((heightAspect) ? Math.floor(height / heightAspect) : 0);
    imgHeight = height || ((heightAspect) ? Math.floor(width * heightAspect) : 0);
  } else if (heightAspect) {
    imgHeight = Math.floor(imgWidth * heightAspect);
  }

  if (smart && !focalPoint) {
    thumbor.smartCrop(true);
  } else if (
    focalPoint
    && focalPoint.length === 2
    && imgWidth !== 0
    && thumbor.filtersCalls
    && thumbor.filtersCalls.length === 0
  ) {
    // left, top, right, bottom
    thumbor.filter(`focal(${focalPoint[0] - 5}x${focalPoint[1] + 5}:${focalPoint[0] + 5}x${focalPoint[1] - 5})`);
  }

  if (fitIn && imgWidth !== 0 && imgHeight !== 0) {
    thumbor.fitInFlag = true;
    thumbor.width = imgWidth;
  } else {
    thumbor.resize(imgWidth, imgHeight);
  }

  let formatUrl = thumbor.setImagePath(imgSrc).buildUrl();

  if (formatUrl.indexOf('fallback-promo-image') > -1) {
    formatUrl = src;
  }

  return formatUrl;
};

export default sizeImage;
